// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"DeliveryAndGuaranteesMessage_messageContainer__GNedH","isNewTypographyEnabled":"DeliveryAndGuaranteesMessage_isNewTypographyEnabled__hzz4C"};